import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getWallet } from "@/lib/api";

const LABELS = { ai_video: "Generazione video e Reel AI", landing_ai: "Creazione landing", retargeting: "Retargeting", whatsapp_automation: "Automazioni WhatsApp", scheduled_reports: "Invio report programmati" };

export function usePlanFeatures() {
  const [state, setState] = useState({ ready: false, error: false, features: null });
  useEffect(() => {
    let alive = true;
    let request = 0;
    const load = async () => {
      const current = ++request;
      try {
        const wallet = await getWallet();
        if (alive && current === request) setState({ ready: true, error: false, features: wallet.plan_features || {} });
      } catch {
        if (alive && current === request) setState({ ready: true, error: true, features: null });
      }
    };
    load();
    window.addEventListener("focus", load);
    window.addEventListener("nadia-wallet-refresh", load);
    return () => { alive = false; window.removeEventListener("focus", load); window.removeEventListener("nadia-wallet-refresh", load); };
  }, []);
  return { ...state, allows: (feature) => state.ready && !state.error && state.features?.[feature] !== false };
}

export function ProFeatureNotice({ access, feature }) {
  if (!access.ready || access.allows(feature)) return null;
  if (access.error) return <div className="nadia-card p-4 mb-5 text-sm text-amber-200" role="status">Verifica del piano non disponibile. Ricarica la pagina prima di continuare.</div>;
  return <div className="nadia-card p-4 mb-5 border-violet-400/25 text-sm text-slate-300" data-testid={"pro-feature-" + feature}>
    <p><strong className="text-violet-200">{LABELS[feature]} · Nadia Pro</strong></p>
    <p className="mt-1">Questa funzione richiede Pro. Con Start puoi caricare e utilizzare foto e video propri. Le elaborazioni AI restano a consumo di gettoni.</p>
    <Link to="/piani?plan=pro" className="inline-block mt-3 text-cyan-200 hover:underline">Confronta i piani</Link>
  </div>;
}

export function ProFeatureGate({ feature, children }) {
  const access = usePlanFeatures();
  if (!access.ready) return <div className="nadia-card p-5 text-sm text-slate-400" role="status">Verifica del piano…</div>;
  return access.allows(feature) ? children : <ProFeatureNotice access={access} feature={feature} />;
}
